var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationsFunnelActionsAbTest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "k3ec4nv6ua",
    d: "M0 0H96V48H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "sbxqx633ac",
    d: "M0 0H96V48H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 48)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "gx40cxaumb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k3ec4nv6ua"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D54CFA",
    d: "M53.613-44.87L93.299-5.186c3.124 3.125 3.124 8.19 0 11.314L53.613 45.815c-3.124 3.125-8.19 3.125-11.314 0L2.613 6.13c-3.124-3.124-3.124-8.19 0-11.314L42.299-44.87c3.124-3.124 8.19-3.124 11.314 0z",
    mask: "url(#gx40cxaumb)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "usg2xk8tpd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#sbxqx633ac"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0072FF",
    d: "M53.613 3.13l39.686 39.685c3.124 3.125 3.124 8.19 0 11.314L53.613 93.815c-3.124 3.125-8.19 3.125-11.314 0L2.613 54.13c-3.124-3.124-3.124-8.19 0-11.314L42.299 3.13c3.124-3.124 8.19-3.124 11.314 0z",
    mask: "url(#usg2xk8tpd)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 28,
    r: 15,
    fill: "#99C7FF",
    stroke: "#FFF",
    strokeOpacity: 0.5,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 68,
    r: 15,
    fill: "#E281FD",
    stroke: "#FFF",
    strokeOpacity: 0.5,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFF",
    fontFamily: "Inter-SemiBold, Inter",
    fontSize: 16,
    fontWeight: 500,
    letterSpacing: -0.3
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 42.36,
    y: 32
  }, "A")), /*#__PURE__*/React.createElement("text", {
    fill: "#FFF",
    fontFamily: "Inter-SemiBold, Inter",
    fontSize: 16,
    fontWeight: 500,
    letterSpacing: -0.3
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 42.891,
    y: 73
  }, "B"))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationsFunnelActionsAbTest);
export default __webpack_public_path__ + "static/media/illustrations-funnel-actions-ab-test.9bb16028.svg";
export { ForwardRef as ReactComponent };